<template>
  <div>
    <h1 class="pb-3">Processamento 2D/3D em tempo</h1>
    <div class="text-justify">
      <BeautifulList v-bind:items="items" />
    </div>
  </div>
</template>

<script>
import BeautifulList from "@/components/BeautifulList.vue";

export default {
  name: "Processamento2D3DTempo",
  components: {
    BeautifulList
  },
  data() {
    return {
      items: [
        { id: 1, text: 'Geometria da aquisição (verificação de mapas, tabelas, posicionamento geodésico, etc.)'},
        { id: 2, text: 'Mapas de desvio do cabo (“cable drift”, em aquisições marinhas)'},
        { id: 3, text: 'Edição visual dos registros'},
        { id: 4, text: 'Correção de divergência esférica e balanceamento das amplitudes'},
        { id: 5, text: 'Deconvolução instrumental (ajuste de fase: explosivo x vibradores-se necessário)'},
        { id: 6, text: 'Remoção do fantasma da fonte em aquisição com explosivo, se necessário'},
        { id: 7, text: 'Deconvolução da assinatura da fonte – em aquisições marinhas'},
        { id: 8, text: 'Marcação das primeiras quebras,cálculo e aplicação da estática de refração'},
        { id: 9, text: 'Atenuação de ruídos no domínio do tiro'},
        { id: 10, text: 'Atenuação de ruídos no domínio do offset– se necessário'},
        { id: 11, text: 'Atenuação do ruído “ swell “ – em dados marinhos'},
        { id: 12, text: 'Balanceamento das amplitudes com consistência em superfície (tiro,receptor e offset)'},
        { id: 13, text: 'Deconvolução com consistência em superfície (tiro e receptor)ou traço a traço (a escolha é feita após testes comparativos de eficiência)'},
        { id: 14, text: 'Atenuação de ruídos no domínio CDP'},
        { id: 15, text: 'Balanceamento espectral (se necessário)'},
        { id: 16, text: 'Análises de velocidade em seções inteiras'},
        { id: 17, text: 'Correção estática residual com consistência superficial - aplicar pelo menos duas iterações'},
        { id: 18, text: 'Análise de velocidade após cada iteração'},
        { id: 19, text: 'Estática Trim, se necessário'},
        { id: 20, text: 'Correção de nmo e empilhamento dos dados'},
        { id: 21, text: 'Regularização dos Gathers (mesmo offset para migração 3D)'},
        { id: 22, text: 'Migração Pós-empilhamento'},
        { id: 23, text: 'Migração Pré-Empilhamento (PSTM Kirchhoff)'},
        { id: 24, text: 'Análise de velocidade residual'},
        { id: 25, text: 'Empilhamento e filtros finais pós-empilhamento(SVD, filtro FK, etc)'},
        { id: 26, text: 'Escalonamento, se necessário'},
        { id: 27, text: 'Filtro de frequências'},
        { id: 28, text: 'Dados de saída gravados em SEG-Y'},
        { id: 29, text: 'Cálculo de parâmetros de raio para aplicação do método CRS'},
        { id: 30, text: 'Aplicação do empilhamento CRS'},
        { id: 31, text: 'Dados de saída gravados em formato SEG-Y'},
        { id: 32, text: 'Migração do empilhamento CRS'},
      ]
    }
  }
};
</script>
